import React, { useEffect, useState } from "react"
import ConfigWrapper from "../optionalFeatures/widget/ConfigWrapper"
import { FeaturesCheckbox } from "../optionalFeatures/widget/FearturesInputTypes/FeatureInputs"
import { Box, TextField } from "@mui/material"
import GenricMultiSelect from "../../../../components/Input/GenericMultiSelect";
import { ChannelkartNetworkGet } from "../../../../services/networkService";
import { openPopup } from '../../../../stateManagement/actions/popupActions';
interface Props{
    name:string,
    values:any,
setValues: React.Dispatch<React.SetStateAction<any>>;

}
export const PasswordComplexityCustom=(props:Props)=>{
    const [options, setOptions] = useState<string[]>([]);
    const defaults = {
  minLength: 8,
  maxLength: 20
}

     const [minLength, setMinLength] = useState<number>(defaults.minLength);
       const [maxLength, setMaxLength] = useState<number>(defaults.maxLength);
        const [passwordConfigValues, setPasswordConfigValues] = useState<any>({});
         const [prevPasswordAllowed, setPrevPasswordAlowed] = useState<string>("1");
         const [allDesignations, setAllDesignations] = useState<string[]>([])
     const passwordComplexityCheckboxes = [
    { name: "upper", label: "Require at least one Upper case letter [A-Z]" },
    { name: "lower", label: "Require at least one Lower case letter [a-z]" },
    { name: "numeric", label: "Require at least one numeric entity [0-9]" },
    { name: "special", label: "Require at least one Special Character (@#$%^&+=)" },
    { name: "length", label: "Require length validation" },
    { name: "prevPasswordCheck", label: "Validate for previous passwords" },
  ];
    const handleCheckboxChange = (option: string) => {
    const updatedOptions = options.includes(option)
      ? options.filter((item: string) => item !== option)
      : [...options, option];
    setOptions(updatedOptions);
  };
  const handlePrevPasswordAllowed = (e: React.ChangeEvent<HTMLInputElement>) => {
      setPrevPasswordAlowed(e.target.value);
    };
  
   const handleMinLengthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const length = parseInt(e.target.value);
      setMinLength(length);
    };
    const handleMaxLengthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newLength = parseInt(e.target.value);
        setMaxLength(newLength)
      }
    return(
          <>
                      {passwordComplexityCheckboxes.map(({ name, label }) => (
                        <React.Fragment key={name}>
                          <Box mb={1} sx={{ display: "flex", justifyContent: "flex-start" }}>
                            <FeaturesCheckbox
                              onChange={() => handleCheckboxChange(name)}
                              name={name}
                              label={label}
                              checked={options.includes(name)}
                            />
                          </Box>
        
                          {/* Render min and max length fields directly after 'length' checkbox */}
                          {name === "length" && options.includes("length") && (
                            <>
                              <Box mb={2} ml={2}>
                                <TextField
                                  type="number"
                                  label="Set minimum length"
                                  onChange={handleMinLengthChange}
                                  value={minLength}
                                  name="minLength"
                                  inputProps={{ min: 0 }}
                                  size="small"
                                  fullWidth
                                />
                              </Box>
                              <Box mb={2} ml={2}>
                                <TextField
                                  type="number"
                                  label="Set maximum length"
                                  onChange={handleMaxLengthChange}
                                  value={maxLength}
                                  name="maxLength"
                                  inputProps={{ min: 0 }}
                                  size="small"
                                  fullWidth
                                />
                              </Box>
                            </>
                          )}
        
                          {/* Render prevPasswordAllowed field directly after 'prevPasswordCheck' checkbox */}
                          {name === "prevPasswordCheck" && options.includes("prevPasswordCheck") && (
                            <Box ml={2} sx={{ display: "flex", justifyContent: "flex-start" }}>
                              <TextField
                                type="number"
                                label="Number of previous passwords to be checked"
                                onChange={handlePrevPasswordAllowed}
                                value={prevPasswordAllowed}
                                name="prevPasswordAllowed"
                                inputProps={{ min: 0 }}
                                size="small"
                                fullWidth
                              />
                            </Box>
                          )}
                        </React.Fragment>
                      ))}
        
        
                  </>
    )
}
export const PasswordRetry=(props:Props)=>{
     const [passwordConfigValues, setPasswordConfigValues] = useState<any>({});
      const [prevPasswordAllowed, setPrevPasswordAlowed] = useState<string>("1");
      const [allDesignations, setAllDesignations] = useState<string[]>([]);
      const passwordRetryCheckboxGroups = [
    {
      key: "app",
      labelPrefix: "on App",
      checkboxes: [
        { name: "blockUser", label: "Block Users" },
        { name: "unblockAfterTimePeriod", label: "Unblock after time period" },
      ],
    },
    {
      key: "portal",
      labelPrefix: "on Portal",
      checkboxes: [
        { name: "blockUser", label: "Block Users" },
        { name: "unblockAfterTimePeriod", label: "Unblock after time period" },
      ],
    },
  ];

  const passwordRetryTextFieldGroups = [
    {
      key: "app",
      fields: [
        { name: "numberOfAttemptsAllowed", label: "Number Of Attempts Allowed In App" },
        { name: "numberOfMinutesToBeBlocked", label: "Number Of Minutes To Be Blocked On App" },
        { name: "timePeriod", label: "Time Period In App" },
      ],
    },
    {
      key: "portal",
      fields: [
        { name: "numberOfAttemptsAllowed", label: "Number Of Attempts Allowed In Portal" },
        { name: "numberOfMinutesToBeBlocked", label: "Number Of Minutes To Be Blocked On Portal" },
        { name: "timePeriod", label: "Time Period In Portal" },
      ],
    },
  ];
  const handleAppCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const keyName = e.target.name;
      props.setValues({
        ...props.values,
        userLoginBlock: {
          ...props.values.userLoginBlock,
          value: {
            ...props.values.userLoginBlock.value,
            app: {
              ...props.values.userLoginBlock.value.app,
              [keyName]: e.target.checked,
            }
          }
        },
      });
    };
    const handlePortalValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const keyName = e.target.name;
      if (Number(e.target.value) < 0) return;
      props.setValues({
         ...props.values,
        userLoginBlock: {
         ...props.values.userLoginBlock,
          value: {
           ...props.values.userLoginBlock.value,
            portal: {
              ...props.values.userLoginBlock.value.portal,
              [keyName]: e.target.value,
            }
          }
        },
      });
    };
      const handlePortalCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        props.setValues({
           ...props.values,
          userLoginBlock: {
            ...props.values.userLoginBlock,
            value: {
               ...props.values.userLoginBlock.value,
              portal: {
                 ...props.values.userLoginBlock.value.portal,
                [keyName]: e.target.checked,
              }
            }
          },
        });
      };
        const handleAppValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const keyName = e.target.name;
          // const abc = Number(e.target.value);
          if (Number(e.target.value) < 0) return;
          props.setValues({
             ...props.values,
            userLoginBlock: {
              ...props.values.userLoginBlock,
              value: {
                ...props.values.userLoginBlock.value,
                app: {
                   ...props.values.userLoginBlock.value.app,
                  [keyName]: e.target.value,
                }
              }
            },
          });
        };
          const handleKeyDown = (event: any) => {
            if (event.key === '-' || event.key === 'e') {
              event.preventDefault();
            }
          };
          
    
    return(
           <>
                      {passwordRetryCheckboxGroups.map(({ key, labelPrefix, checkboxes }) =>
                        checkboxes.map(({ name, label }) => (
                          <Box key={`${key}-${name}`} mb={1} sx={{ display: "flex", justifyContent: "flex-start" }}>
                            <FeaturesCheckbox
                              onChange={key === "app" ? handleAppCheckChange : handlePortalCheckChange}
                              name={name}
                              label={`${label} ${labelPrefix}`}
                              checked={props.values?.userLoginBlock?.value?.[key]?.[name]}
                            />
                          </Box>
                        ))
                      )}
        
                      {passwordRetryTextFieldGroups.map(({ key, fields }) =>
                        fields.map(({ name, label }) => (
                          <TextField
                            key={`${key}-${name}`}
                            label={label}
                            value={props.values?.userLoginBlock?.value?.[key]?.[name]}
                            onChange={key === "app" ? handleAppValueChange : handlePortalValueChange}
                            name={name}
                            type="number"
                            inputProps={{ min: 0 }}
                            onKeyDown={handleKeyDown}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                          />
                        ))
                      )}
                    </>
    )
}
export const PasswordDeactivateInactiveUsers=(props:Props)=>{
    const [loading, setLoading] = useState<boolean>(false);
      const init = async () => {
        try {
          setLoading(true);
          
          const response = await ChannelkartNetworkGet(
            '/v1/divisions?sort=level:asc&size=100&source=portal&callType=scheduled'
          );
          const features = response.data.features;
          const tempDesignations: string[] = [];
          features.forEach((feature: any) => {
            if (feature.divisionName) {
              tempDesignations.push(feature.divisionName);
            }
          });
          setAllDesignations(tempDesignations);
        } catch (error) {
          console.error("Error in fetching the config", error);
          openPopup("Error", "Error in fetching the config", () => { });
        } finally {
          setLoading(false);
        }
      }
      useEffect(()=>{
        init();
      },[])
    const [allDesignations, setAllDesignations] = useState<string[]>([]);

    const handleKeyDown = (event: any) => {
            if (event.key === '-' || event.key === 'e') {
              event.preventDefault();
            }
          };
      const handleInactivityValueChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const keyName = e.target.name;
        if (Number(e.target.value) < 0) return;
        props.setValues({
          ...props.values,
          userInactivityBlock: {
            ...props.values.userInactivityBlock,
            value: {
              ...props.values.userInactivityBlock.value,
              [keyName]: e.target.value,
            }
          },
        });
      };
    
    return(
           <>
                      <TextField
                        label="Inactivity Days after which user will be deactivated"
                        value={props.values?.userInactivityBlock?.value?.inactivityConfigDays}
                        onChange={handleInactivityValueChnage}
                        name="inactivityConfigDays"
                        type="number"
                        onKeyDown={handleKeyDown}
                        variant="outlined"
                        fullWidth
                        inputProps={{ min: 0 }}
                        sx={{ mt: 0, mb: 2 }}
                      />
        
        
                      <GenricMultiSelect
                        label='Designations to be deactivated'
                        selectedOptions={props.values?.userInactivityBlock?.value?.designationToBlockOnInactivity}
                        options={allDesignations}
                        handleMultiSelectState={(selectedOptions: string[]) => {
                          props.setValues({
                            ...props.values,
                            userInactivityBlock: {
                              ...props.values?.userInactivityBlock,
                              value: {
                                ...props.values?.userInactivityBlock.value,
                                designationToBlockOnInactivity: selectedOptions
                              }
                            },
                          });
                        }}
                        isRequired={false}
                      />
                    </>
    )
}